import { Checkbox } from '@mui/material';

import type { CatalogCheckState } from '../../utils/catalogSelection';

interface TriStateCheckboxProps {
  state: CatalogCheckState;
  onToggle: () => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/** MUI checkbox driven by the catalog tri-state (`on` / `partial` / `off`). */
export function TriStateCheckbox({ state, onToggle, disabled, ariaLabel }: TriStateCheckboxProps) {
  return (
    <Checkbox
      size="small"
      disableRipple
      checked={state === 'on'}
      indeterminate={state === 'partial'}
      disabled={disabled}
      inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
      sx={{ p: 0.5 }}
    />
  );
}

export default TriStateCheckbox;
